import type { StringTable } from '../types'

export const fr: StringTable = {
  'common.playbackSpeed': 'Vitesse de lecture',
  // Navigation
  'nav.review': 'Réviser',
  'nav.library': 'Bibliothèque',
  'nav.stats': 'Stats',
  'nav.settings': 'Paramètres',
  'nav.appTitleSuffix': 'Flashcards de vocabulaire',
  'nav.openMenu': 'Ouvrir le menu',
  'nav.closeMenu': 'Fermer le menu',
  'nav.mainNav': 'Navigation principale',
  'nav.reviewSession': 'Session de révision',
  'nav.cardLibrary': 'Bibliothèque de cartes',
  'nav.media': 'Vidéos',
  'nav.statistics': 'Statistiques',
  'nav.create.label': 'Créer',
  'nav.create.text': 'Texte',
  'nav.create.doc': 'Document',
  'nav.create.media': 'Vidéo / Audio',

  // Generate view
  'generate.takePhoto': 'Photo',
  'generate.changePhoto': 'Changer la photo',
  'generate.chooseGallery': 'Galerie',
  'generate.clearText': 'Effacer le texte',
  'generate.button': 'Générer des cartes',
  'generate.buttonPhoto': 'Générer depuis la photo',
  'generate.buttonText': 'Générer depuis le texte',
  'generate.buttonBoth': 'Générer depuis photo + texte',
  'generate.buttonLoading': 'Génération...',
  'generate.minInput': 'Ajoutez une photo ou du texte pour commencer',
  'generate.convertingHeic': 'Conversion HEIC...',
  'generate.compressing': 'Compression...',
  'generate.retry': 'Réessayer',
  'generate.removeImage': 'Supprimer l\'image',
  'generate.cardTextInput': 'Saisie du texte de la carte',
  'generate.preview': 'Aperçu',

  // Generate errors
  'generate.error.invalidImage': 'Veuillez importer une image (JPEG, PNG, GIF, WebP ou HEIC)',
  'generate.error.imageTooLarge': 'L\'image doit faire moins de {{maxSize}}',
  'generate.error.compressionFailed': 'L\'image est toujours trop grande après compression. Essayez une photo plus petite.',
  'generate.error.heicFailed': 'Échec du traitement de l\'image',
  'generate.error.generateFailed': 'Échec de la génération des cartes',

  // Generate — daily cap / upgrade
  'generate.cap.body': 'Votre solde est vide ({{balance}} énergie). Rechargez pour continuer.',
  'generate.cap.upgrade': 'Recharger',

  // Generate — energy badge + first-session banner (balance visibility)
  'generate.energyBadge.label': "Solde d'énergie : {{balance}}",
  'generate.energyBadge.zero': "Plus d'énergie",
  'generate.firstCard.body': "Vous avez {{balance}} d'énergie — assez pour vos premières cartes. Tapez un mot ci-dessous pour essayer →",
  'generate.firstCard.dismiss': 'Fermer',
  'generate.sampleWords.label': 'Essayez :',
  'generate.aiImageToggle': 'Image IA',
  'generate.aiImageHint': "Ajoute une image IA aux cartes que vous gardez ({{cost}}/carte)",
  'generate.aiImageAutoSkip': "Certaines images IA n'ont pas pu être ajoutées — appuyez sur le bouton image de chaque carte pour réessayer.",

  // Library view
  'library.loading': 'Chargement de la bibliothèque...',
  'library.retry': 'Réessayer',
  'library.noCards': 'Pas encore de cartes !',
  'library.noCardsHint': 'Génère des flashcards pour construire ta bibliothèque.',
  'library.emptyExtensionHint': 'Astuce : sélectionne un mot sur YouTube et enregistre-le avec l’extension Piccard.',
  'library.emptyCta': 'Créer ta première carte',
  'library.dismiss': 'Fermer',
  'library.deleteTitle': 'Supprimer la carte ?',
  'library.deleteConfirm': 'Cette action est irréversible. Tu es sûr ?',
  'library.cancel': 'Annuler',
  'library.deleting': 'Suppression...',
  'library.delete': 'Supprimer',
  'library.filterAll': 'Toutes',
  'library.filterLearning': 'En cours',
  'library.filterMastered': 'Maîtrisées',
  'library.card_one': '{{count}} carte',
  'library.card_other': '{{count}} cartes',
  'library.match_one': '{{count}} résultat',
  'library.match_other': '{{count}} résultats',
  'library.noCardsMatch': 'Aucune carte ne correspond à « {{query}} »',
  'library.prevPage': 'Page précédente',
  'library.nextPage': 'Page suivante',
  'library.searchImagesFor': 'Chercher des images pour {{word}}',
  'library.unmaster': 'Annuler la maîtrise de {{word}}',
  'library.markMastered': 'Marquer {{word}} comme maîtrisé',
  'library.searchPlaceholder': 'Chercher{{filter}} des cartes...',
  'library.drag': 'GLISSER',
  'library.swipeHint': '← Supprimer · Voir →',
  'library.back': 'Verso',
  'library.images': 'Images',
  'library.master': 'Maîtriser',
  'library.mastered': 'Maîtrisée',
  'library.view': 'Voir',
  'library.fromMedia': 'D\'un média',
  'library.fromDoc': 'D\'un document',

  // Review view
  'review.ready': 'Prêt à réviser ?',
  'review.readyHint': 'Choisis un sujet ou commence avec toutes les cartes dues',
  'review.recognition': 'Reconnaissance',
  'review.production': 'Production',
  'review.topics': 'Sujets',
  'review.domains': 'Domaines',
  'review.startReview': 'Commencer la révision',
  'review.loading': 'Chargement des cartes...',
  'review.retry': 'Réessayer',
  'review.tapFlip': 'Appuie pour retourner',
  'review.answer': 'Réponse',
  'review.newWord': 'Nouveau mot',
  'review.cardProgress': 'Carte {{current}} sur {{total}}',
  'review.searchImagesFor': 'Chercher des images pour {{word}}',
  'review.allCaughtUp': 'Tout est à jour !',
  'review.nothingToReview': 'Rien à réviser pour le moment.',
  'review.makeSomeCards': 'Créer des cartes',
  'review.makeMoreCards': 'Créer plus de cartes « {{topic}} »',
  'review.backToReview': 'Retour à la révision',
  'review.noMatchTitle': 'Aucune carte ne correspond à « {{topic}} »',
  'review.noMatchHint': 'Inclut les cartes qui correspondent partiellement à ton sujet',
  'review.fallbackTitle': 'Aucune carte ne correspond à « {{topic }} » — voici tout ce qui est dû',
  'review.sessionComplete': 'Session terminée !',
  'review.cardsReviewed': 'Cartes révisées',
  'review.again': 'Encore',
  'review.hard': 'Difficile',
  'review.good': 'Bien',
  'review.easy': 'Facile',
  'review.timeSpent': 'Temps passé',
  'review.cardReviewed_one': '{{count}} carte révisée aujourd\'hui',
  'review.cardReviewed_other': '{{count}} cartes révisées aujourd\'hui',
  'review.startNewSession': 'Nouvelle session',

  // Share check-in card (issue #1 — /s/:slug poster pages)
  'share.cta': 'Partager ma carte du jour',
  'share.title': 'Partager mes progrès',
  'share.name': 'Nom affiché',
  'share.create': 'Créer un lien de partage',
  'share.copied': 'Lien copié !',
  'share.open': 'Ouvrir la page de partage',
  'share.saveImage': "Enregistrer l'image",
  'share.myLinks': 'Mes liens de partage',
  'share.revoke': 'Révoquer',
  'share.empty': 'Pas encore de lien — termine une session de révision pour partager ta série.',
  'review.tapOrSpace': 'Appuie sur la carte ou Espace pour retourner',
  'review.images': 'Images',
  'review.prefillMore': 'plus de mots et expressions sur {{topic}}',
  'review.endSession': 'Terminer la session',
  'review.error.loadFailed': 'Échec du chargement des cartes',
  'review.error.submitFailed': 'Échec de l\'envoi de la révision',

  // Stats view
  'stats.today': 'Aujourd\'hui',
  'stats.reviewedToday': 'révisées aujourd\'hui',
  'stats.review_one': 'révision',
  'stats.review_other': 'révisions',
  'stats.mastered': 'maîtrisées',
  'stats.learned': 'mots appris',
  'stats.word_one': 'mot',
  'stats.word_other': 'mots',
  'stats.error': 'Impossible de charger les statistiques',
  'stats.dailyGoal': 'Objectif du jour',
  'stats.goalFresh': 'Un nouveau départ.',
  'stats.goalGoing': 'Continuez.',
  'stats.goalMet': 'Objectif atteint, beau travail.',
  'stats.goalHint': 'Touchez pour régler votre rythme',

  // Settings view
  'settings.title': 'Paramètres',
  'settings.languagePair': 'Paire de langues',
  'settings.learn': 'Apprendre',
  'settings.pairOption': '{{native}} → Apprendre {{target}}',
  'settings.pairGroup': '{{langA}} ↔ {{langB}}',
  'settings.cardsPerSession': 'Cartes par session',
  'settings.cardLabel': '{{count}} cartes',
  'settings.changeWarning': 'Changer la langue rechargera l\'application',
  'settings.apply': 'Appliquer',
  'settings.cancelChange': 'Annuler',

  // Settings — learning context (free-text goal that tunes AI generation)
  'settings.learningContext.label': 'Objectif d\'apprentissage',
  'settings.learningContext.optional': 'optionnel',
  'settings.learningContext.placeholder': 'ex. vocabulaire GRE, HSK, anglais des affaires…',
  'settings.learningContext.hint': 'Influence les mots choisis par l\'IA. Vide pour les valeurs par défaut.',
  'settings.learningContext.try': 'Essayer :',
  'settings.learningContext.example1': 'Prépa HSK',
  'settings.learningContext.example2': 'Anglais des affaires',
  'settings.learningContext.example3': 'Conversation quotidienne',
  'settings.learningContext.example4': 'Anglais australien',

  // Settings — subscription
  'settings.plan.balanceTitle': 'Solde d\'énergie',
  'settings.plan.balanceDesc': '{{balance}} énergie disponible',
  'settings.plan.topup': 'Recharger ${{amount}}',
  'settings.plan.energyUnit': '{{energy}} énergie',
  'settings.plan.bonusPct': '+{{percent}}% bonus',
  'settings.plan.bestValue': 'Meilleure valeur',
  'settings.support.title': "Besoin d'aide ?",
  'settings.support.desc': 'Questions, facturation ou retours — écrivez-nous.',
  'settings.referral.title': 'Invitez des amis, vous recevez chacun 150 énergie',
  'settings.referral.desc': 'Partagez votre lien. Quand un ami recharge, vous recevez chacun 150 énergie gratuites.',
  'settings.referral.yourCode': "Votre code d'invitation",
  'settings.referral.copyCode': "Copier le code d'invitation",
  'settings.referral.tapToCopy': 'Toucher pour copier',
  'settings.referral.codeCopied': 'Copié',
  'settings.referral.shareLink': 'Partager le lien',
  'settings.referral.invited_one': '{{count}} ami invité',
  'settings.referral.invited_other': '{{count}} amis invités',
  'settings.referral.toppedUp_one': '{{count}} a rechargé',
  'settings.referral.toppedUp_other': '{{count}} ont rechargé',
  'settings.referral.pendingHint': 'En attente de leur première recharge — rappelez-leur !',
  'settings.referral.shareText': 'Apprenez le vocabulaire avec les photos de votre vie. À chaque recharge, nous gagnons 150 énergie chacun — essayez Piccard :',
  'settings.referral.rewardBanner': 'Votre ami a rechargé — 150 énergie ajoutées à votre solde.',
  'settings.referral.rewardDismiss': 'Compris',
  'settings.referral.haveCode': "Vous avez un code d'invitation ?",
  'settings.referral.codePlaceholder': 'Saisir le code',
  'settings.referral.codeApply': 'Appliquer',
  'settings.referral.codeApplying': 'Application…',
  'settings.referral.codeApplied': 'Code appliqué — quand vous rechargez, vous et votre parrain recevez 150 énergie chacun.',
  'settings.referral.codeAlready': 'Une invitation est déjà appliquée à votre compte.',
  'settings.referral.codeInvalid': "Ce code n'est pas valide.",
  'settings.referral.codeSelf': "C'est votre propre code.",

  // Payment (shared)
  'payment.checkoutFailed': 'Impossible de lancer le paiement. Réessayez.',
  'payment.checkoutLoading': 'Ouverture du paiement…',
  'payment.checkoutSuccess': 'Recharge reçue — merci !',
  'payment.checkoutCancelled': 'Paiement annulé.',

  // Hamburger menu
  'menu.notSignedIn': 'Non connecté',
  'menu.signOut': 'Déconnexion',
  'menu.languageLearner': 'Apprenant',

  // Onboarding
  'onboarding.iSpeak': 'Je parle…',
  'onboarding.imLearning': 'J\'apprends…',
  'onboarding.startLearning': 'Commencer',
  'onboarding.changeAnytime': 'Tu peux changer ça à tout moment.',
  'onboarding.back': '← Retour',
  'onboarding.learningContext.label': 'Tu étudies pour quelque chose de précis ?',
  'onboarding.learningContext.placeholder': 'ex. GRE, HSK, anglais des affaires… (optionnel)',

  // Auth
  'auth.signInPrompt': 'Connecte-toi pour sauvegarder ton vocabulaire dans le cloud',
  'auth.continueWithGoogle': 'Continuer avec Google',
  'auth.continueWithKakao': 'Continuer avec Kakao',
  'auth.signingIn': 'Connexion...',
  'auth.signingYouIn': 'Connexion en cours...',
  'auth.signInFailed': 'Échec de la connexion',
  'auth.signInError': 'Un problème est survenu lors de l\'authentification.',
  'auth.tryAgain': 'Réessayer',
  'auth.loading': 'Chargement...',

  // Error boundary
  'error.title': 'Un problème est survenu',
  'error.description': 'Une erreur inattendue s\'est produite.',
  'error.tryAgain': 'Réessayer',
  'error.report': 'Signaler',

  // Offline
  'offline.title': 'Tu es hors ligne',
  'offline.description': 'Certaines fonctionnalités peuvent être limitées. Vérifie ta connexion.',
  'offline.notification': 'Notification hors ligne',
  'offline.retryConnection': 'Réessayer la connexion',

  // PWA install
  'pwa.installPrompt': 'Installer Piccard pour un accès hors ligne',
  'pwa.install': 'Installer',
  'pwa.dismiss': 'Fermer',
  'pwa.installAppPrompt': 'Invitation à installer l\'application',
  'pwa.installApp': 'Installer l\'application',

  // Card stack
  'cardStack.cardGenerated': '1 carte générée',
  'cardStack.cardGenerated_other': '{{count}} cartes générées',
  'cardStack.counter': '{{current}} / {{total}} cartes',
  'cardStack.done': 'Terminé',
  'cardStack.reviewNow': 'Réviser maintenant',
  'cardStack.generateMore': 'Générer plus',
  'cardStack.allReviewed': 'Toutes les cartes ont été revues',
  'cardStack.cardsSaved': '{{count}} cartes enregistrées',
  'cardStack.previousCard': 'Carte précédente',
  'cardStack.nextCard': 'Carte suivante',
  'cardStack.goToCard': 'Aller à la carte {{n}}',

  // Preview card
  'previewCard.generatedCard': 'Carte générée',
  'previewCard.translation': 'Traduction',
  'previewCard.definition': 'Définition',
  'previewCard.example': 'Exemple',
  'previewCard.searchImagesFor': 'Chercher des images pour {{word}}',

  // Rating buttons
  'rating.again': 'Encore',
  'rating.hard': 'Difficile',
  'rating.good': 'Bien',
  'rating.easy': 'Facile',
  'rating.master': 'Maîtriser',
  'rating.rateAs': 'Évaluer comme {{label}}',
  'rating.markMastered': 'Marquer comme maîtrisé',
  'review.stuckHint': "Cette carte vous a échappé {{count}}× — ce n'est pas de votre faute, certaines cartes ne tiennent pas. Retirez-la ci-dessous ou continuez.",

  // Study card
  'studyCard.studyCardFor': 'Carte d\'étude : {{word}}',
  'studyCard.playUsPronunciation': 'Écouter la prononciation américaine',
  'studyCard.playUkPronunciation': 'Écouter la prononciation britannique',
  'studyCard.searchImagesFor': 'Chercher des images pour {{word}}',

  // Pronunciation button + badge
  'pronunciation.play': 'Écouter la prononciation {{accent}}',

  // Search bar
  'search.clearSearch': 'Effacer la recherche',

  // Tag cloud
  'tagCloud.yourTopics': 'Tes sujets',
  'tagCloud.showMore': 'Afficher {{count}} {{label}} de plus',

  // Queue item
  'queueItem.remove': 'Retirer {{word}}',

  // Error card
  'errorCard.defaultRetry': 'Réessayer',

  // Empty state
  'emptyState.noCards': 'Pas encore de cartes',
  'emptyState.noCardsHint': 'Crée ta première flashcard pour commencer',
  'emptyState.createCard': 'Créer une carte',
  'emptyState.noMastered': 'Pas encore de mots maîtrisés.',
  'emptyState.noMasteredHint': 'Marque des cartes comme maîtrisées pour les voir ici.',
  'emptyState.allMastered': 'Toutes tes cartes sont maîtrisées !',
  'emptyState.greatJob': 'Bravo !',

  // Progress bar
  'progressBar.cardsLearned': 'Cartes apprises',

  // AI image regeneration (shared RegenerateImageButton)
  'common.aiImage': 'Image IA',
  'common.aiImagePremium': 'Premium',
  'common.aiImageAria': 'Générer une image IA pour {{word}}',
  'common.generating': 'Génération…',
  'common.imageFailed': 'Échec · aucune énergie utilisée',
  'common.lowEnergy': 'Énergie faible',
  'common.regenerateCard': 'Régénérer',
  'common.regenerateCardAria': 'Régénérer complètement {{word}}',

  // Image preview / lightbox
  'imagePreview.enlarge': 'Agrandir l\'image',
  'imagePreview.close': 'Fermer',

  // Document import view (PDF/TXT → candidate vocab)
  'importView.title': 'Importer un document',
  'importView.subtitle': 'Transformez un PDF ou un texte en cartes de vocabulaire.',
  'importView.chooseFile': 'Choisir un fichier PDF ou texte',
  'importView.pasteLabel': 'Ou collez du texte',
  'importView.pastePlaceholder': 'Collez votre article, notes ou tout texte…',
  'importView.findVocab': 'Trouver du vocabulaire',
  'importView.proposing': 'Recherche de vocabulaire…',
  'importView.parsing': 'Lecture du document…',
  'importView.candidates': '{{count}} candidats',
  'importView.keepN': 'Garder {{count}} · {{energy}} énergie',
  'importView.generate': 'Générer {{count}} cartes',
  'importView.selectAll': 'Tout sélectionner',
  'importView.clearAll': 'Tout effacer',
  'importView.priorityHigh': 'Haute valeur',
  'importView.highCount': '{{high}} à forte valeur sur {{total}}',
  'mediaView.selectRecommended': 'Sélectionner les recommandées',
  'importView.success': '{{count}} cartes ajoutées à votre bibliothèque',
  'importView.pairMismatch': 'Les cartes seront enregistrées en {{pair}} — votre app est réglée sur {{current}}. Changez dans Réglages pour les réviser.',
  'importView.savedAs': 'Enregistré en {{pair}}',
  'importView.reviewInPair': 'Passer en {{pair}} et réviser',
  'importView.reviewNow': 'Réviser maintenant',
  'importView.errorTooLarge': 'Document trop volumineux (max ~800K caractères).',
  'importView.errorScanned': 'Aucun texte sélectionnable — PDF numérisé ?',
  'importView.errorRead': 'Impossible de lire ce fichier.',
  'importView.errorPropose': "Impossible d'extraire le vocabulaire. Réessayez.",
  'importView.errorRateLimited': 'Trop de requêtes à la suite. Attendez une minute, puis réessayez.',
  'importView.errorLowEnergy': "Pas assez d'énergie pour enregistrer ces cartes.",
  'importView.empty': 'Aucun vocabulaire trouvé. Essayez un autre document.',
  'importView.proposingWait': 'Sélection des mots et rédaction des définitions — 10 à 20 s pour les textes longs.',
  'importView.phaseReading': 'Lecture de ton texte…',
  'importView.foundSoFar': '{{n}} trouvés · recherche en cours…',
  'importView.cancel': 'Annuler',
  'importView.partialBanner': '{{n}} mots trouvés, mais l’analyse s’est arrêtée avant la fin.',
  'importView.retryRest': 'Trouver le reste',

  // Quick save view (extension lookup → one-step card)
  'quickSave.title': 'Enregistrer dans Piccard',
  'quickSave.subtitle': 'Un appui et ta carte est prête à réviser.',
  'quickSave.generate': 'Générer la carte',
  'quickSave.generateCost': 'Générer la carte · {{energy}} d’énergie',
  'quickSave.generating': 'Création de ta carte…',
  'quickSave.slowWait': 'La création de ta carte prend généralement quelques secondes.',
  'quickSave.pairSourceExtension': 'de cette vidéo',
  'quickSave.pairSourceSettings': 'réglage de l’app',
  'quickSave.pairSourceBrowser': 'langue du navigateur',
  'quickSave.fromYoutube': 'De cette vidéo',
  'quickSave.fromNetflix': 'De cette série',
  'quickSave.pairLabel': 'Langue de la carte',
  'quickSave.energyHint': 'Générer coûte {{energy}} d’énergie · solde {{balance}}',
  'quickSave.errorBalance': 'Pas assez d’énergie pour générer cette carte.',
  'quickSave.errorNetwork': 'Impossible de générer la carte. Réessaie.',
  'quickSave.topUp': 'Recharger',
  'card.fromSource': 'De votre document',
  'card.grammar': 'Grammaire',
  'card.prosody': 'Accent et rythme',
  'card.fromClip': 'Extrait',
  'card.fromYoutube': 'YouTube',
  'card.openInNetflix': 'Ouvrir sur Netflix',
  'card.fromNetflix': 'Netflix',
  'card.fromPdf': 'PDF',
  'card.fromPhoto': 'Votre photo',
  'card.lookedUp': 'Mot recherché',
  'card.expand': 'Déplier',
  'card.collapse': 'Replier',

  'mediaView.title': 'Transforme un clip en cartes',
  'mediaView.subtitle': 'Importe un audio ou vidéo en anglais. On transcrit, tu choisis.',
  'mediaView.chooseFile': 'Dépose le fichier ou touche pour choisir',
  'mediaView.formats': 'mp4 · mov · webm · mp3…',
  'mediaView.cap': 'Jusqu’à 90 min · jusqu’à 100 Mo',
  'mediaView.guideExtension.body': "Extension installée ? Sélectionnez un mot des sous-titres sur une vidéo YouTube/Netflix et touchez le bouton Piccard pour l'enregistrer en carte. Vous pouvez aussi importer votre propre fichier vidéo/audio ci-dessous →",
  'mediaView.guideExtension.dismiss': 'Fermer',
  'mediaView.uploading': 'Envoi…',
  'mediaView.transcribe': 'Transcrire',
  'mediaView.transcribing': 'Transcription…',
  'mediaView.transcribeHint': 'Un court clip prend quelques secondes.',
  'mediaView.changeFile': 'Changer de fichier',
  'mediaView.costN': '{{energy}} énergie',
  'mediaView.phrases': '{{count}} phrases',
  'mediaView.make': 'Créer {{count}} cartes',
  'mediaView.uncertain': 'Vérifie cette phrase',
  'mediaView.preview': 'Lire cette phrase',
  'mediaView.success': '{{count}} cartes prêtes à réviser',
  'mediaView.errorUpload': 'Échec de l’envoi. Réessaie.',
  'mediaView.errorTooLarge': 'Plus de 100 Mo — raccourcis-le.',
  'mediaView.errorSilent': "Aucune parole audible détectée. Peut-être une vidéo muette — choisis un clip avec dialogue.",
  'mediaView.errorFormat': 'Format non pris en charge. Utilise mp4, mov, webm ou un fichier audio.',
  'mediaView.errorTranscribe': 'Service occupé. Réessaie — non facturé.',
  'mediaView.tooLongDuration': 'Plus de {{n}} minutes — raccourcis le clip, puis rajoute-le.',
  'mediaView.errorContent': 'Aucune parole en anglais détectée dans ce fichier.',
  'mediaView.errLanguageMismatch': 'Ce clip ne semble pas être en {{lang}}. Choisissez un média en {{lang}} ou changez d\'abord votre langue d\'apprentissage.',
  'mediaView.errBadFormat': 'Le format réel de ce fichier ne peut pas être transcrit (ex. un .avi/.mkv renommé en .mp4). Convertissez-le en mp4, mov, webm ou un format audio standard.',
  'mediaView.errNoSpeech': 'Aucune voix détectée dans ce fichier. Choisis un clip avec un dialogue clair.',
  'mediaView.errDecode': "L'audio de ce fichier n'a pas pu être traité. Essaie un fichier mp4, mov, webm ou audio standard.",
  'mediaView.fromFile': 'de {{name}}',
  'mediaView.errorLowEnergy': 'Pas assez d’énergie.',
  'mediaView.errorConfirm': 'Impossible de créer des cartes depuis ces phrases. Réessaie.',
  'mediaView.empty': 'Aucune phrase trouvée dans ce clip.',
  'mediaView.costEstimate': '~{{cost}} énergie · ~{{min}} min',
  'mediaView.feeApplied': '({{n}} énergie de détection prélevée)',
  'settings.section.energy': 'Énergie',
  'settings.section.learning': 'Apprentissage',
  'redeem.title': 'Utiliser un code',
  'redeem.desc': 'Saisis un code pour recevoir de l\'énergie.',
  'redeem.placeholder': 'Saisir le code',
  'redeem.apply': 'Utiliser',
  'redeem.applying': '…',
  'redeem.success': 'Utilisé ! +{{cents}} énergie',
  'redeem.already': 'Tu as déjà utilisé ce code.',
  'redeem.invalid': 'Code invalide ou expiré',
  'redeem.error': 'Une erreur est survenue. Réessaie.',
  'redeem.balance': '{{balance}} énergie disponible',

  // Landing page (v11 — extension-first entry, closed loop. Copy frozen in
  // docs/plans/landing-v11.md; locale from ?lang / ?ref hint / navigator.languages)
  'landing.hero.title': 'Apprenez l’anglais\navec YouTube.',
  'landing.hero.subtitle': 'Des sous-titres bilingues sur les vidéos en anglais que vous regardez. Touchez une ligne, faites les cartes en un clic — sens, phrase d’exemple, prononciation — et chacune revient juste avant que vous l’oubliiez.',
  'landing.hero.cta': 'Commencer',
  'landing.hero.ctaNote': 'Gratuit. Sans carte bancaire.',
  'landing.hero.ctaExtension': 'Ajouter à Chrome',
  'landing.hero.videoCaption': 'Du panneau bilingue jusqu’à Piccard — une ligne devient plusieurs cartes candidates.',
  'landing.how.title': 'Des sous-titres aux cartes de vocabulaire',
  'landing.how.subtitle': 'La boucle se referme toute seule : ce que vous regardez devient ce que vous révisez.',
  'landing.how.step1Title': 'Regardez avec des sous-titres bilingues',
  'landing.how.step1Desc': 'L’extension Chrome superpose des sous-titres dans votre langue sur la vidéo que vous regardez — chaque ligne, synchronisée à la seconde près.',
  'landing.how.step2Title': 'Touchez une ligne. Gardez les cartes.',
  'landing.how.step2Desc': 'Un appui envoie la ligne dans Piccard. Un clic fait les cartes — sens, phrase d’exemple, prononciation sur chacune. Gardez ce qui compte, écartez le reste.',
  'landing.how.step3Title': 'La révision vient à vous',
  'landing.how.step3Desc': 'La répétition espacée FSRS planifie le retour de chaque carte juste avant que vous l’oubliiez — et chacune rejoue le moment YouTube exact d’où elle vient.',
  'landing.how.otherTitle': 'Autres points d’entrée',
  'landing.how.other3': 'Double-cliquez sur un mot sur le web — une définition hors ligne s’affiche, et Piccard crée la carte en un clic de plus.',
  'landing.how.ownLink': 'Vous avez déjà une liste de mots ? Apportez-la →',

  // landing-v12 P1-2: persona-2 section (OwnMaterial.tsx) — bring your own list
  'landing.bring.title': 'Apportez votre propre liste',
  'landing.bring.subtitle': 'Les vidéos ne sont qu’une entrée parmi d’autres. La plupart des mots dont vous avez besoin existent déjà quelque part — un chapitre de manuel, la liste d’un examen, un enregistrement de cours. Collez ou importez : Piccard propose les cartes, et vous gardez celles qui valent la peine d’être apprises.',
  'landing.bring.pasteTitle': 'Collez le texte',
  'landing.bring.pasteDesc': 'Une page de manuel, un article, la liste que vous avez déjà. Collez-la et les cartes proposées reviennent — tout sélectionner, ou ne garder que l’essentiel. Jusqu’à 20 cartes par confirmation.',
  'landing.bring.pdfTitle': 'Déposez un PDF',
  'landing.bring.pdfDesc': 'Supports de cours, listes d’examen, lectures — un PDF passe par la même proposition. Les cartes s’affichent, vous cochez, une confirmation.',
  'landing.bring.fileTitle': 'Importez un audio ou une vidéo',
  'landing.bring.fileDesc': 'Un cours ou un podcast en anglais (jusqu’à 90 minutes) est transcrit — chaque phrase reçoit un score de 0 à 100 d’intérêt pédagogique (votre objectif compte) et les phrases à garder arrivent pré-cochées. L’audio doit être dans la langue que vous apprenez (anglais, si vous apprenez l’anglais).',
  'landing.bring.cta': 'Ouvrir l’app',
  'landing.bring.ctaNote': 'Gratuit pour commencer. Sans carte bancaire.',
  'landing.pricing.title': 'Ne payez que ce que vous utilisez',
  'landing.pricing.subtitle': 'Commencez avec de l’énergie gratuite. Rechargez quand vous voulez — elle n’expire jamais.',
  'landing.pricing.starter': 'Démarrage',
  'landing.pricing.starterPrice': '$0',
  'landing.pricing.starterToBegin': 'pour commencer',
  'landing.pricing.starterGrant': '150 d’énergie offerte à l’inscription',
  'landing.pricing.starterSwitch': 'Changez de langue à tout moment',
  'landing.pricing.starterSrs': 'Répétition espacée complète',
  'landing.pricing.starterDevices': 'Fonctionne sur tout appareil',
  'landing.pricing.starterSync': 'Synchronisation cloud incluse',
  'landing.pricing.starterCta': 'Commencer',
  'landing.pricing.topup': 'Packs de recharge',
  'landing.pricing.topupRate': '1 énergie ≈ 1 carte texte',
  'landing.pricing.starterAiImage': 'Cartes texte incluses ; les cartes image IA sont une fonction payante',
  'landing.pricing.topupCards': '500 cartes pour $5',
  'landing.blog.backHome': '← Accueil',
  'landing.welcome.openApp': 'Ouvrir Piccard',
  'landing.faq.heading': 'Questions fréquentes',
  'landing.faq.q1': 'Piccard est-il vraiment gratuit ?',
  'landing.faq.a1': 'Oui ! Chaque nouveau compte reçoit 150 d’énergie gratuite, de quoi couvrir quelques vidéos, quelques PDF, ou environ 150 cartes. Rechargez avec des packs d’énergie ($5/$10/$20) uniquement si vous en voulez plus. L’énergie n’expire jamais.',
  'landing.faq.q2': 'En quoi est-ce différent de Language Reactor ou Anki ?',
  'landing.faq.a2': 'Ce sont deux bons outils avec un vide entre eux : Language Reactor affiche les sous-titres, mais sauvegarder des mots suppose exporter puis importer dans Anki, et Anki lui-même demande une vraie configuration — vous construisez chaque carte à la main. Piccard comble ce vide. Touchez une ligne de sous-titres et les cartes sont déjà faites — sens, phrase d’exemple, prononciation — gardez ce qui compte, écartez le reste, et FSRS-6, le nouveau planificateur qu’Anki propose aussi, s’occupe de la répétition espacée. Et lors de l’import de vidéos plus longues, chaque phrase reçoit un score de 0 à 100 d’intérêt à apprendre — raison en une ligne au survol, votre objectif d’apprentissage pris en compte —, vous ne devez plus deviner quels mots méritent votre temps. Sans configuration, sans passerelle export/import.',
  'landing.faq.q3': 'Va-t-il ralentir YouTube ou casser les sous-titres ?',
  'landing.faq.a3': 'Non. L’extension est légère — elle ajoute son propre panneau de sous-titres par-dessus la vidéo et ne modifie jamais YouTube lui-même. Si vous ne la voulez plus, un clic retire tout. Elle fonctionne aussi sans compte.',
  'landing.faq.q5': 'Qu’est-ce que la répétition espacée ?',
  'landing.faq.a5': 'Un algorithme de planification décide quand chaque carte doit revenir — tôt quand elle est fraîche, plus tard quand elle s’installe dans la mémoire à long terme. Piccard utilise FSRS-6, la génération la plus récente de la science derrière Anki, et vos cartes naissent de ce que vous regardez et lisez.',
  'landing.faq.q7': 'Quelles langues Piccard prend-il en charge ?',
  'landing.faq.a7': '한국어 · 繁體中文 · 日本語 en priorité — Piccard est conçu pour les locuteurs coréen, chinois traditionnel et japonais qui apprennent l’anglais. Espagnol, français et allemand aussi disponibles. Changez quand vous voulez.',

  'landing.faq.q8': 'J’ai déjà ma liste de mots. Piccard peut-il la transformer en cartes ?',
  'landing.faq.a8': 'Oui — c’est la voie la plus rapide. Collez le texte ou déposez le PDF et Piccard propose les cartes (jusqu’à 20 à la fois) : sens, phrase d’exemple et prononciation. Les enregistrements de cours fonctionnent aussi — importez l’audio, il est transcrit et chaque phrase reçoit un score de 0 à 100.',
  'landing.faq.q9': 'Est-ce que ça marche sur Netflix ?',
  'landing.faq.a9': 'Oui, pour les titres sous-titrés en texte — si le titre propose les deux langues, Piccard affiche des sous-titres bilingues (anglais + votre langue) sur la vidéo. Regardez avec le panneau Piccard ouvert, touchez une réplique et elle devient une carte qui renvoie à la seconde exacte sur Netflix. Certains titres utilisent des sous-titres en image, illisibles ; et le DRM interdit captures et audio — ce que vous gardez, ce sont les mots et l\'instant.',
  'landing.faq.still': 'Encore des questions ? Écrivez à',
  'landing.footer.tagline': 'Des cartes de vocabulaire tirées de ce que vous regardez',
  'landing.footer.blog': 'Blog',
  'landing.footer.privacy': 'Confidentialité',
  'landing.footer.terms': 'Conditions',
  'landing.footer.contact': 'Contact',
  'landing.footer.rights': 'Tous droits réservés.',
  'landing.finalCta.title': 'Votre première fiche de révision n’est qu’à une vidéo YouTube',
  'landing.finalCta.subtitle': 'Regardez quelque chose. Touchez une ligne. Créez la carte — elle revient avant que vous l’oubliiez.',
  'landing.finalCta.cta': 'Commencer gratuitement',
  'landing.finalCta.ctaExtension': 'Ajouter à Chrome',
  'landing.finalCta.note': 'Sans carte bancaire. 150 d’énergie incluse.',

  // SEO — prerendered HTML shells (docs/plans/multilingual-seo.md M1)
  'seo.title': 'Apprendre l’anglais avec YouTube : sous-titres bilingues | Piccard',
  'seo.description': 'Des sous-titres bilingues sur YouTube. Touchez une ligne, gardez les cartes de vocabulaire qui comptent, révisez avec la répétition espacée (FSRS).',
}
